/* The v3 fleet console for school bus organisations (/fleet/*). Every job the
   classic dashboard did now has a page or a dialog here (2026-10-28); its
   address, /fleet/classic, still opens it until the console has been tested. */
import React, { Suspense } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import './console.css';
import Shell from './Shell';
import { FleetDataProvider, FleetModelProvider } from './data/FleetData';
import type { FleetModel } from './data/model';
import Overview from './pages/Overview';
import LiveMap from './pages/LiveMap';
import Alerts from './pages/Alerts';
import Buses from './pages/Buses';
import Fuel from './pages/Fuel';
import Maintenance from './pages/Maintenance';
import Trips from './pages/Trips';
import People from './pages/People';
import Report from './pages/Report';
import Analytics from './pages/Analytics';
import FuelPrices from './pages/FuelPrices';
import Settings from './pages/Settings';
import Billing from './pages/Billing';
import ZanaChat from './pages/ZanaChat';
import NotFound from './pages/NotFound';

const Pages: React.FC = () => (
    <Shell>
      <Suspense fallback={null}>
        <Routes>
          <Route index element={<Overview />} />
          <Route path="map" element={<LiveMap />} />
          <Route path="alerts" element={<Alerts />} />
          <Route path="buses" element={<Buses />} />
          <Route path="fuel" element={<Fuel />} />
          <Route path="maintenance" element={<Maintenance />} />
          <Route path="trips" element={<Trips />} />
          <Route path="people" element={<People />} />
          <Route path="report" element={<Report />} />
          <Route path="analytics" element={<Analytics />} />
          <Route path="fuel-prices" element={<FuelPrices />} />
          <Route path="settings" element={<Settings />} />
          <Route path="billing" element={<Billing />} />
          <Route path="zana" element={<ZanaChat />} />
          <Route path="overview" element={<Navigate to="/fleet" replace />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Suspense>
    </Shell>
);

/** `model` replaces the live data (tests and previews); without it the console reads Firestore. */
const ConsoleApp: React.FC<{ model?: FleetModel }> = ({ model }) => (
  model
    ? <FleetModelProvider value={model}><Pages /></FleetModelProvider>
    : <FleetDataProvider><Pages /></FleetDataProvider>
);

export default ConsoleApp;
